import { Instagram, Facebook } from "lucide-react";

export function TikTokIcon({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
            <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.25-.02-.5-.02-.76.02-1.71.77-3.4 2.03-4.56 1.47-1.37 3.56-2.05 5.55-1.82.16.02.32.04.48.06v4.19c-.29-.08-.58-.17-.88-.22-.65-.11-1.34-.06-1.94.2-.94.38-1.65 1.24-1.87 2.23-.08.4-.09.82-.01 1.22.18 1.03.99 1.92 2 2.22.62.18 1.3.18 1.92-.01.95-.29 1.7-1.1 1.96-2.06.08-.35.11-.72.1-1.09.01-4.72.01-9.44.01-14.16z" />
        </svg>
    );
}

export function WhatsAppIcon({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
        </svg>
    );
}

const icons = {
    Instagram: Instagram,
    Facebook: Facebook,
    TikTok: TikTokIcon,
};

export default function SocialIcons({ socials, variant = "dark", testPrefix = "social" }) {
    const color = variant === "dark" ? "text-cream/80 hover:text-gold-light" : "text-ink/70 hover:text-brick";
    const border = variant === "dark" ? "border-white/15 hover:border-gold/50" : "border-ink/15 hover:border-brick/50";
    return (
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            {socials.map((s) => {
                const Icon = icons[s.platform];
                return (
                    <a
                        key={s.platform}
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`${testPrefix}-${s.platform.toLowerCase()}`}
                        aria-label={s.platform}
                        className={`group flex items-center gap-2.5 rounded-full border px-4 py-2.5 transition-all duration-300 ${color} ${border} hover:-translate-y-0.5`}
                    >
                        <Icon className="h-4 w-4" />
                        <span className="text-xs font-medium tracking-wide">{s.handle}</span>
                    </a>
                );
            })}
        </div>
    );
}
